import styled from 'styled-components'
import * as stylesConstants from '../../../../assets/constants/ui'

const Bound = styled.div`
    display: flex;
    flex: 1;
    padding-top: ${stylesConstants.HEADER_HEIGHT + stylesConstants.MAIN_CONTENT_PADDING_TOP}px;
`

export { Bound }